import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Box, Chip, TableFooter } from "@mui/material";
import { DoneAll, Clear, ExpandMoreTwoTone, ExpandLessTwoTone } from "@mui/icons-material";
import React, {useEffect, useState} from 'react'
import { motion } from "framer-motion";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Laptop from '../Assets/laptop.png'
import Report from '../Assets/report.png'
import SoftwareDevelopment from '../Assets/software-development.png'
import Content from '../Assets/content.png'
import Smartphone from '../Assets/smartphone.png'
import CustomerService from '../Assets/customer-service.png'
import '../CSS/Module.css'

export default function Health() {
    const [pricing, setPricing] = useState(false);
    const [showAll, setShowAll] = useState(false);
    
    useEffect(() => {
      AOS.init({ duration: 1000 }); 
    }, []);

    const handleToggleChange = () => {
        setPricing(!pricing)
    }

    const features = [
        { name: "SMS Integration*", basic: true, advanced: true, premium: true },
        { name: "WhatsApp Integration*", basic: true, advanced: true, premium: true },
        { name: "Payment Gatway Integration*", basic: true, advanced: true, premium: true },
        { name: "User Role and Permission", basic: true, advanced: true, premium: true },
        { name: "Enquiry Management", basic: true, advanced: true, premium: true },
        { name: "Admission Management", basic: true, advanced: true, premium: true },
        { name: "Transport Management", basic: true, advanced: true, premium: true },
        { name: "Fee Management", basic: true, advanced: true, premium: true },
        { name: "Fee Dues Management", basic: true, advanced: true, premium: true },
        { name: "Fee Concession Management", basic: true, advanced: true, premium: true },
        { name: "Denominator", basic: true, advanced: true, premium: true },
        { name: "Attendance Management", basic: false, advanced: true, premium: true },
        { name: "I-Card Management", basic: false, advanced: true, premium: true },
        { name: "Student Gate Pass", basic: false, advanced: true, premium: true },
        { name: "Visitor Pass", basic: false, advanced: true, premium: true },
        { name: "Appreciation Certificate", basic: false, advanced: true, premium: true },
        { name: "Bonafide/TC/Fee Certificate", basic: false, advanced: true, premium: true },
        { name: "Exam Management", basic: false, advanced: true, premium: true },
        { name: "Time Table Management", basic: false, advanced: false, premium: true },
        { name: "Library Management", basic: false, advanced: false, premium: true },
        { name: "Homework Management", basic: false, advanced: false, premium: true },
        { name: "Notice Management", basic: false, advanced: false, premium: true },
        { name: "Employee Management", basic: false, advanced: false, premium: true },
        { name: "Account Management", basic: false, advanced: false, premium: true },
        { name: "Student Web Login", basic: false, advanced: false, premium: true },
        { name: "Student App", basic: false, advanced: false, premium: true },
        { name: "Teacher App", basic: false, advanced: false, premium: true },
    ];

    const plans = [
        { name: "Basic", color: "primary" },
        { name: "Advanced", color: "secondary", popular: true },
        { name: "Premium", color: "success" },
    ];

    const displayedFeatures = showAll ? features : features.slice(0, 10);

  return (
    <>
        <section id="Solutions" className="d-flex align-items-center pt-5">
            <div className="container" data-aos="fade-up">
                <div className="section-title">
                    <h2>Features</h2>
                    <h3>Diagnostic Lab Management Software <span>Features</span></h3>
                </div>
                <div className="row shadow-sm mx-1">
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-end">
                        <img src={Laptop}alt="laptop" width="40" className="icon" />
                        <h4 className="title">Easy To Use</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center">
                        <img src={Report} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Attractive report based on critical and normal values</h4>
                    </div> 
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-md-start border-sm-top border-sm-end">
                        <img src={SoftwareDevelopment} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Software Update time to time</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top border-md-end">
                        <img src={Content} alt="laptop" width="40" className="icon " />
                        <h4 className="title">Patient Result Entry With Minimal Effort</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top">
                        <img src={Smartphone} alt="laptop" width="40" className="icon" />
                        <h4 className="title">SMS Module Integration</h4>
                    </div>
                    <div className="fade-up col-6 col-md-4 d-flex flex-column justify-content-center align-items-center border-top border-start">
                        <img src={CustomerService} alt="laptop" width="40" className="icon" />
                        <h4 className="title">Customer Support 24*7</h4>
                    </div>
                </div>
                <nav className='my-5 mx-2'>
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <span className={`nav-link ${!pricing && 'active'}`} onClick={handleToggleChange}>Modules</span>
                      </li>
                      {/* <li className="nav-item">
                        <span className={`nav-link ${pricing && 'active'}`} onClick={handleToggleChange}>Pricing</span>
                      </li> */}
                    </ul>
                </nav>
                {!pricing &&
                    <div className="container">
                        <div className="section-title" data-aos="fade-up">
                          <h2>Modules</h2>
                          <h3>Software Module <span>Details</span></h3>
                        </div>
                        <div className="row">
                            <div className="col-md-4" data-aos="fade-right">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Test Management</h5>
                                        <li>Add/Edit Test Group</li>
                                        <li>Add/Edit Test/Price List</li>
                                        <li>Add/Edit Interpretation</li>
                                        <li>Test Serial Number Management</li>
                                        <li>Bulk Update Test Rate</li>
                                        <li>Bulk Update Test Type</li>
                                        <li>Bulk Copy Test (Create New Test)</li>
                                        <li>Test Formula</li>
                                    </ul>
                                    <ul>
                                        <h5>Package Management</h5>
                                        <li>Create Package</li>
                                        <li>Add Test in Package</li>
                                    </ul>
                                    <ul>
                                        <h5>Referrer Management</h5>
                                        <li>Add Referrer</li>
                                        <li>View/Edit Referrer</li>
                                        <li>Add Benefit Percent for Pathology/X-Ray/Ultrasound/ECG Billing</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4" data-aos="fade-down">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Patient Management</h5>
                                        <li>Patient Registration</li>
                                        <li>Search Patient with Multiple Filter</li>
                                        <li>Waiting List</li>
                                        <li>Result Entry with Remarks</li>
                                        <li>Result Approval</li>
                                        <li>Print Report</li>
                                        <li>Report with Barcode/QR Code</li>
                                        <li>Reports with Pathologist Name and Signature</li>
                                        <li>Report PDF on Single Click</li>
                                        <li>Reports with Header/Footer</li>
                                        <li>Send SMS</li>
                                        <li>Share Report on WhatsApp/Email</li>
                                        <li>Download Report on Scan QR</li>
                                    </ul>
                                    <ul>
                                        <h5>Billing Management</h5>
                                        <li>Pathology/X-Ray/Ultrasound/ECG Billing</li>
                                        <li>Billing Details with Multiple Filter</li>
                                        <li>Bill Outstanding Details with Multiple filter</li>
                                        <li>Collection Details with Multiple Filter</li>
                                        <li>Dash Board (Date Filter)</li>
                                        <li>Test Count</li>
                                        <li>Date & Department wise Collection Report</li>
                                        <li>Referrer Wise Patient and Collection</li>
                                        <li>Client Wise Patient and Collection</li>
                                        <li>Month Wise Income</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-4" data-aos="fade-up">
                                <div className="shadow-lg bg-white rounded border module-card">
                                    <ul>
                                        <h5>Accounts Management</h5>
                                        <li>Add Ledger</li>
                                        <li>Bill Entry</li>
                                        <li>Voucher Entry (Payment/Journal)</li>
                                        <li>View/Print Ledger Statement</li>
                                    </ul>
                                    <ul>
                                        <h5>Benefit Management (Auto Benefit Calculation)</h5>
                                        <li>View/Print Test Wise Benefit</li>
                                        <li>View/Print Patient Wise Benefit</li>
                                        <li>View/Print Benefit Paid</li>
                                    </ul>
                                    <ul>
                                        <h5>User Management</h5>
                                        <li>User Accounts with Privilege</li>
                                        <li>Auto Data Backup</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {pricing &&
                  <Box sx={{ maxWidth: 1400, mx: "auto", textAlign: "center", p: 2 }} data-aos="fade-down">
                    <Typography variant="h3" fontWeight={600} color="primary" gutterBottom>Compare Plans</Typography>
                    <TableContainer sx={{ overflow: "scroll" }}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell align="center" sx={{ transform: "scale(1.1)", background: "#D0021B", color: "white", fontWeight: "bold", fontSize: "0.8rem", padding: "4px 10px", borderTopLeftRadius: '10px', borderTopRightRadius: '10px', boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)"}}>Most Popular</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                          <TableRow sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"}}>
                            <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "1.2rem", borderTopLeftRadius: '10px' }}>Features</TableCell>
                            {plans.map((plan, idx) => (
                              <TableCell key={idx} sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, position: "relative", transform: plan.popular ? "scale(1.1)" : "none", zIndex: plan.popular ? 2 : 1, backgrounBenefitolor: plan.popular ? "rgba(255, 255, 255, 0.2)" : "inherit", backdropFilter: plan.popular ? "blur(5px)" : "none", borderRadius: plan.popular ? "8px" : "0px", borderTopRightRadius: plan.popular ? "0px" : "10px", boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none" }} align="center">
                                {plan.name}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayedFeatures.map((feature, index) => (
                            <TableRow key={index} sx={{ backgrounBenefitolor: index % 2 === 0 ? "#f9f9f9" : "#fff", "& td": { py: 1 } }}>
                              <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>{feature.name}</TableCell>
                              {plans.map((plan, idx) => (
                                <TableCell key={idx} align="center" sx={{
                                  transform: plan.popular ? "scale(1.1)" : "none",
                                  zIndex: plan.popular ? 2 : 1,
                                  backgrounBenefitolor: plan.popular ? "rgba(255, 255, 255, 0.3)" : "inherit",
                                  backdropFilter: plan.popular ? "blur(5px)" : "none",
                                  borderRadius: plan.popular ? "8px" : "0px",
                                  boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.5)" : "none"
                                }}>
                                  {feature[plan.name.toLowerCase()] ? (
                                    <motion.div whileHover={{ scale: 1.2 }}>
                                      <DoneAll color="success" fontSize="medium" />
                                    </motion.div>
                                  ) : (
                                    <motion.div whileHover={{ scale: 1.2 }}>
                                      <Clear color="error" fontSize="medium" />
                                    </motion.div>
                                  )}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                        <TableFooter>
                          <Chip sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)", background: "#D0021B", color: "#fff", zIndex: 3 }} icon={showAll ? <ExpandLessTwoTone color="white" /> : <ExpandMoreTwoTone color="white" />} onClick={() => setShowAll(!showAll)} label={showAll ? "Show Less" : "View More"} />
                          <TableRow sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)"}}>
                            <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, borderTopLeftRadius: '10px' }}>NO OF STUDENTS</TableCell>
                            {plans.map((plan, idx) => (
                              <TableCell key={idx} sx={{ color: "white", fontWeight: "bold", fontSize: { xs: "1rem", sm: "1.1rem" }, position: "relative", transform: plan.popular ? "scale(1.1)" : "none", zIndex: plan.popular ? 2 : 1, backgroundcolor: plan.popular ? "rgba(255, 255, 255, 0.2)" : "inherit", backdropFilter: plan.popular ? "blur(5px)" : "none", borderRadius: plan.popular ? "8px" : "0px", borderTopRightRadius: plan.popular ? "0px" : "10px", boxShadow: plan.popular ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none" }} align="center">
                                {plan.name}
                              </TableCell>
                            ))}
                          </TableRow>
                          <TableRow sx={{ backgroundcolor: "#f9f9f9", "& td": { py: 1 } }}>
                            <TableCell sx={{  background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>Upto 300</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">9,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundcolor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">14,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">19,999/Year</TableCell>
                          </TableRow>
                          <TableRow sx={{ backgroundcolor: "#fff", "& td": { py: 1 } }}>
                            <TableCell sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>301- 500</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">14,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundcolor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">19,999/Year</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">24,999/Year</TableCell>
                          </TableRow>
                          <TableRow sx={{ backgroundcolor: "#f9f9f9", "& td": { py: 1 } }}>
                            <TableCell sx={{ background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", color: "#fff", fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }}>500 +</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">Rs. 5/Per Student/Per Month</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" }, transform: "scale(1.1)", zIndex: 2, backgroundcolor: "rgba(255, 255, 255, 0.3)",  backdropFilter: "blur(5px)", borderRadius: "8px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.5)"}} align="center">Rs 7/Per Student/Per Month</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: { xs: "0.75rem", sm: "0.9rem" } }} align="center">Rs 10/Per Student/Per Month</TableCell>
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </Box>
                }
            </div>
        </section>
    </>
  )
}
